"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressCheck = void 0;
/**
 * This service is used to autocomplete the address details
 * @param data The data for the request.
 * @param data.houseNumber House number
 * @param data.postcode Postal code
 * @returns GetAddressCheckResponse OK
 * @throws ApiError
 */
const getAddressCheck = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/util/address/check/v1',
        query: {
            house_number: data.houseNumber,
            postcode: data.postcode
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getAddressCheck = getAddressCheck;
